import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import ModalSuccess from './ModalSuccess';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const ModalSuccessContainer = ({ object, action, resetActionCallback, pathToNavigateAfterSuccess }) => {
    const [open, setOpen] = useState(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        return () => {
            resetActionCallback && dispatch(resetActionCallback());
        };
    }, [dispatch, resetActionCallback]);

    const handleClose = () => {
        setOpen(false);

        // without setTimeout end of animation doesn't work
        setTimeout(() => {
            resetActionCallback && dispatch(resetActionCallback());
        }, 100);

        if (pathToNavigateAfterSuccess) {
            navigate(pathToNavigateAfterSuccess);
        }
    };

    return <ModalSuccess object={object} action={action} open={open} handleClose={handleClose} />;
};

ModalSuccessContainer.propTypes = {
    object: PropTypes.string,
    action: PropTypes.string,
    resetActionCallback: PropTypes.func,
    pathToNavigateAfterSuccess: PropTypes.string,
};

export default ModalSuccessContainer;
